import React from 'react';
import icon from '../../assets/images/loading.svg';

export const LoadingComponent = ({loading}) => {
    return (
        <div
            style={{
                display: loading ? 'flex' : 'none',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                marginBottom: 15,
                marginTop: 15
            }}
        >
            <img src={icon} />
        </div>
    );
}

export default LoadingComponent;